import FeaturedEvents from "@/components/FeaturedEvents";
import WhySerava from "@/components/WhySerava";
import HowItWorks from "@/components/HowItWorks";
import Newsletter from "@/components/Newsletter";
import EnquiryForm from "@/components/EnquiryForm";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

export default function HomePage() {
  const { t } = useLang();
  return (
    <main data-testid="home-page">
      <section className="pt-28 pb-12 md:pt-32 md:pb-16 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-10 h-[1px] bg-[#C5A059]" />
              <span className="text-[11px] tracking-[0.4em] uppercase text-[#C5A059] font-['Outfit'] font-medium">{t("hero_tag")}</span>
            </div>
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl md:text-6xl font-medium tracking-[-0.02em] text-white leading-[1.1] mb-3">{t("hero_title")}</h1>
            <p className="text-white/45 font-['Outfit'] font-light text-base max-w-xl leading-relaxed">{t("hero_subtitle")}</p>
          </motion.div>
        </div>
      </section>
      <FeaturedEvents />
      <div className="section-divider" />
      <WhySerava />
      <div className="section-divider" />
      <HowItWorks />
      <div className="section-divider" />
      <Newsletter />
      <div className="section-divider" />
      <section id="contact" data-testid="contact-section" className="py-24 md:py-32 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
              <span className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-['Outfit'] font-semibold block mb-4">{t("contact_tag")}</span>
              <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tight text-white mb-6">{t("contact_title")} <span className="italic text-white/70">{t("contact_title_italic")}</span></h2>
              <p className="text-white/50 font-['Outfit'] font-light text-base leading-relaxed mb-8">{t("contact_desc")}</p>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <span className="text-xs tracking-[0.15em] uppercase text-[#C5A059] font-['Outfit'] font-semibold w-16">Email</span>
                  <span className="text-white/60 font-['Outfit'] font-light text-sm">contact@seravagroup.com</span>
                </div>
              </div>
            </motion.div>
            <EnquiryForm />
          </div>
        </div>
      </section>
    </main>
  );
}
